import state from "./moduleRGPlaybackState.js";
import mutations from "./moduleRGPlaybackMutations.js";
import actions from "./moduleRGPlaybackActions.js";
import getters from "./moduleRGPlaybackGetters.js";

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters,
};
